import {
  catchError,
  concat,
  distinctUntilChanged,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';

import { NgSelectComponent } from '@ng-select/ng-select';

/* eslint-disable @typescript-eslint/no-empty-function */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ApiClientInterface } from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';
import { FilterOperator, FilterType } from '@ideapa/common-interfaces';
import { DropdownPosition } from '@ng-select/ng-select';

export interface AutocompleteSelectConfig {
  searchFields: string[];
  orderBy: { [field: string]: 'asc' | 'desc' };
  apiClient: ApiClientInterface<BaseDto>;
  bindLabel: string;
}

@Component({
  standalone: false,
  selector: 'ideapa-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent
  implements OnChanges, ControlValueAccessor, AfterViewInit
{
  @ViewChild(NgSelectComponent, { static: true })
  select?: NgSelectComponent;

  @Input()
  appendTo?: string = undefined;

  @Input()
  clearable = true;

  @Input()
  searchable = false;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  change = new EventEmitter();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  // @Input()
  // items: any[] = [];
  private _items: any[] = [];
  get items() {
    return this._items;
  }
  @Input()
  set items(values: any[]) {
    this._items = values;
    if (!this.autocompleteConfig) {
      this.items$ = of(values);
    }
  }

  @Input()
  bindValue?: string;

  @Input()
  bindLabel = 'description';

  @Input()
  placeholder = '';

  @Output()
  changed = new EventEmitter();

  isDisabled = false;

  @Input()
  hasError = false;

  @Input()
  multiple = false;

  @Input()
  autocompleteConfig?: AutocompleteSelectConfig;

  @Input()
  minTermLength = 0;

  @Input()
  canAdd? = false;

  @Input()
  canView? = false;

  @Input()
  entityName?: string;

  @Input()
  readOnly = false;

  @Input()
  setFocusOnInit = false;

  @Input()
  dropdownPosition: DropdownPosition = 'auto';

  value: any;

  items$?: Observable<BaseDto[]>;
  dataLoading = false;
  textInput$: Subject<string> = new Subject<string>();

  get typeToSearchText() {
    return `inserisci ${this.minTermLength} o più caratteri per cercare`;
  }

  propagateChange = (value: any) => {};
  validateFn: any = () => {};
  onTouched = () => {};

  constructor(
    private cd: ChangeDetectorRef // private routerFacade: RouterFacade
  ) {}

  ngAfterViewInit(): void {
    // console.log(`select setFocusOnInit: ${this.setFocusOnInit}`);
    if (this.setFocusOnInit) this.select?.focus();
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.cd.markForCheck();
  }

  registerOnChange(fn: (value: any) => void) {
    this.propagateChange = fn;
  }

  setDisabledState(isDisabled: any): void {
    this.isDisabled = isDisabled;
    this.cd.markForCheck();
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(control: FormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.autocompleteConfig) {
      const apiClient = this.autocompleteConfig.apiClient;
      const searchFields = this.autocompleteConfig.searchFields;
      const orderBy = this.autocompleteConfig.orderBy;

      this.items$ = concat(
        of([]), // default items
        this.textInput$.pipe(
          distinctUntilChanged(),
          tap(() => {
            this.dataLoading = true;
          }),
          switchMap((term) =>
            apiClient
              .getPaged(
                10,
                0,
                orderBy,
                searchFields.map((field) => ({
                  field,
                  operator: FilterOperator.contains,
                  value: [term],
                  type: FilterType.text,
                }))
              )
              .pipe(
                map((res) => res.items),
                catchError(() => of([])), // empty list on error
                tap(() => (this.dataLoading = false))
              )
          )
        )
      );
    } else {
      this.items$ = of(this.items);
    }
  }

  onModelChange($event: any) {
    this.changed.emit($event);
    this.propagateChange($event);
    this.onTouched();
  }

  async add() {
    if (this.entityName) {
      // return this.routerFacade.addNewEntity(this.entityName);
    }
  }

  async view() {
    if (this.entityName) {
      // this.routerFacade.viewEntityDetail(this.entityName, this.value);
    }
    // if (w) {
    //   w.onunload = (e) => alert('new window closed');
    // }
  }

  onChange() {
    this.change.emit();
  }
}
